var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgHeartRate(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M15.496 0c.516 0 .984.375 1.125.844l3.703 14.25 1.266-2.672a2.627 2.627 0 012.39-1.547h5.438c.61 0 1.125.516 1.125 1.125a1.11 1.11 0 01-1.125 1.125H23.98a.353.353 0 00-.328.234l-2.625 5.532c-.187.422-.656.656-1.125.609a1.167 1.167 0 01-.984-.797l-3.281-12.61L12.12 23.11c-.094.516-.562.891-1.078.891a1.064 1.064 0 01-1.125-.797l-2.672-9.797a.408.408 0 00-.375-.281H1.668c-.656 0-1.125-.469-1.125-1.125 0-.61.469-1.125 1.125-1.125h5.203c1.172 0 2.203.797 2.531 1.969l1.454 5.25L14.417.937c.094-.515.563-.89 1.078-.937z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgHeartRate);
export default ForwardRef;
